import { ICategoryNews, INews } from 'api/home/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { NextLink } from 'components/blocks/NextLink';
import classNames from 'classnames';
import React from 'react';
import { SwiperComponent } from 'components/blocks/SwiperComponent';
import { ReactComponent as SvgArrowWhiteBg } from 'public/assets/icons/arrow-white-bg.svg';
import { Routes } from 'routes';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import { News } from './News';
import styles from './styles.module.scss';

const swiperBreakpoints = {
  375: {
    slidesPerView: 1.2,
  },
  640: {
    slidesPerView: 1.7,
  },
  1200: {
    slidesPerView: 3,
  },
};

export const NewsList = ({
  title,
  news,
  weatherNews,
  areNewsFresh,
}: {
  title?: string,
  news: Array<INews>,
  weatherNews?: boolean,
  areNewsFresh: boolean,
}) => {
  const { t } = useOTSTranslation('common');
  const showWeatherLink = Boolean(weatherNews);
  const showMoreLink = Boolean(title && !weatherNews);

  const slides = news.map((item: INews | ICategoryNews) => ({
    key: item.uuid,
    content: (
      <News
        areNewsFresh={areNewsFresh}
        news={item}
      />
    ),
  }));

  return (
    <section className={classNames(styles.wrapper, 'mt-4')}>
      {(title || showWeatherLink || showMoreLink) && (
        <div className={styles.header}>
          {title && <h2>{title}</h2>}
          {(showWeatherLink || showMoreLink) && (
            <div className={styles.btn}>
              {showWeatherLink && (
                <NextLink href={Routes.weather}>
                  {t('snowWeather.home.viewAllWeatherNews')}
                </NextLink>
              )}
              {showMoreLink && (
                <NextLink href={Routes.magazine}>
                  {t('common.loadMore')}
                </NextLink>
              )}
            </div>
          )}
        </div>
      )}
      <div className={classNames(styles.wrapperBox, !areNewsFresh && BLUR_CONTENT_STYLE_NAME)}>
        <SwiperComponent
          slides={slides}
          breakpoints={swiperBreakpoints}
          spaceBetween={16}
          navigationThreshold={3}
          sliderWrapperClassName={styles.sliderWrapper}
          swiperClassName={styles.swiper}
          slideClassName={styles.slide}
          navButtonClassName={styles.swiperNavButton}
          prevButtonClassName={styles.swiperButtonPrev}
          nextButtonClassName={styles.swiperButtonNext}
          NavigationIcon={SvgArrowWhiteBg}
        />
      </div>
    </section>
  );
};
